import React from 'react';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <header className="w-full bg-plum-deep text-cream" data-id="element-60" data-mp="ejwk9bk3of7b">
      <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-12 px-6 py-16 md:py-24 lg:grid-cols-12 lg:gap-10" data-id="element-61" data-mp="eibq3n1p6y9z">
        <div className="lg:col-span-7" data-id="element-62" data-mp="9igux7aw3mj4">
          <p className="flex items-center gap-3 font-sans text-sm text-sand/70" data-id="element-63" data-mp="4mi5rhhqm0hn">
            <span aria-hidden="true" className="h-px w-8 bg-clay" data-id="element-64" data-mp="12a0lxddqa4vo" />
            Para terapeutas holísticos que quieren liderar la sesión
          </p>

          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-[3.75rem]" data-id="element-65" data-mp="xb5s7ge82vws">
            Dejá de improvisar en tus sesiones.
            <span className="mt-3 block text-clay" data-id="element-66" data-mp="nbexbdlr2ew6">
              Nunca más te quedes en blanco frente a un paciente.
            </span>
          </h1>

          <p className="mt-7 max-w-2xl font-sans text-lg leading-relaxed text-cream/80" data-id="element-67" data-mp="382fgbrjt9agi">
            El sistema completo de protocolos, mapas corporales y preguntas de
            diagnóstico para conducir tus consultas con la seguridad de un
            profesional y construir autoridad real en tu consultorio.
          </p>

          <div className="mt-10" data-id="element-68" data-mp="39b4ib4a0404i">
            <CtaButton data-id="element-69" data-mp="399ti1efrlai5" />
            <p className="mt-4 font-sans text-sm text-cream/60" data-id="element-70" data-mp="39cpawocr98zq">
              Pago único de $18.900 ARS · Garantía de 7 días · 5 bonos incluidos
            </p>
          </div>
        </div>

        <div className="lg:col-span-5" data-id="element-71" data-mp="30fy9dwffp1xr">
          <div className="relative" data-id="element-72" data-mp="3599ent4llank">
            <div aria-hidden="true" className="absolute -left-3 -top-3 h-full w-full rounded-3xl border border-clay/50" data-id="element-73" data-mp="35aax4iny0zfb" />
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/3604b595-6b90-473e-8f4a-1631d78e13d9.jpg" alt="Mapas corporales impresos, ficha clínica y tablet sobre la mesa de un consultorio holístico" className="relative aspect-[4/3] w-full rounded-3xl object-cover" data-id="element-74" data-mp="2vi53z5lygbyj" />
          </div>
        </div>
      </div>
    </header>;
}